import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new TextColumn('Receiver', 'receiver'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new TextColumn('Receiving mailbox', 'receivingMailbox'),
        new DateTimeColumn('Preparation date', 'preparationDate'),
        new DateTimeColumn('On network date', 'onNetworkDate'),
        new TextColumn('INTREF', 'intref'),
        new TextColumn('Missing from', 'missingFrom'),
        new TextColumn('Missing to', 'missingTo'),
        new NonZeroNumberColumn('Missing count', 'missingCount'),
      ],
    },
  ];
};
